import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "modern-normalize/modern-normalize.css?vue&type=style&index=0&lang=css&external"
import "./styles/global.scss?vue&type=style&index=1&lang=scss&external"
import "./styles/text.scss?vue&type=style&index=2&lang=scss&external"
import "./styles/buttons.scss?vue&type=style&index=3&lang=scss&external"
import "./styles/fx.scss?vue&type=style&index=4&lang=scss&external"
import "./styles/fx-outline.scss?vue&type=style&index=5&lang=scss&external"

const __exports__ = script;

export default __exports__